import { copyIcon } from '@workday/canvas-system-icons-web'
import { canvasIconPaths } from '~/icons/canvasIconPaths'
import { createIcon } from './create-icon'

export const Copy = createIcon({
  viewBox: '0 0 24 24',
  displayName: 'Copy',
  paths: canvasIconPaths(copyIcon)
})
